<img src="assets/auth-header-bg.svg" class="auth-header-hero__bg" alt="" />

<div class="auth-header-hero__overlay">
  <img src="assets/icons/orlikfy-header-v2.svg" class="auth-header-hero__logo" alt="Orlikfy" />
  <p class="auth-header-hero__text">{{ text() }}</p>
</div>
